export const WORK_CATEGORIES = [
  { value: "civil", label: "Obra Civil" },
  { value: "electrica", label: "Ingeniería Eléctrica" },
  { value: "hidraulica", label: "Ingeniería Hidráulica" },
  { value: "estructura_metalica", label: "Estructura Metálica" },
  { value: "estructura_metalica_ligera", label: "Estructura Metálica Ligera" },
  { value: "maquinaria", label: "Maquinaria" },
  { value: "acabados", label: "Acabados" },
];

export const categoryLabel = (v) =>
  (WORK_CATEGORIES.find((c) => c.value === v) || {}).label || v;

export const RECUBRIMIENTOS = [
  "Pintura", "Piedra enchapada", "Piedra laja", "Piso cerámico",
  "Piso porcelanato", "Piso de mármol", "Fachaleta", "Ladrillo",
];

export const QUALITY_OPTIONS = ["Excelente", "Buena", "Regular", "Deficiente"];

export const UNITS = ["m²", "ml", "pza", "m³", "kg", "lote"];

export const EST_STAGES = {
  pendiente_gerente_area: { label: "Pend. Gerente de Área", short: "G. Área", tone: "bg-amber-50 text-amber-700" },
  pendiente_superintendente: { label: "Pend. Superintendente", short: "Superint.", tone: "bg-amber-50 text-amber-700" },
  pendiente_admin: { label: "Pend. Gerente Administrativo", short: "G. Admin", tone: "bg-amber-50 text-amber-700" },
  pendiente_gerente_general: { label: "Pend. Gerente General", short: "G. General", tone: "bg-orange-100 text-orange-700" },
  por_pagar: { label: "Por pagar", short: "Por pagar", tone: "bg-blue-50 text-blue-700" },
  pagado: { label: "Pagado", short: "Pagado", tone: "bg-emerald-50 text-emerald-700" },
  suspendido: { label: "Suspendido / En revisión", short: "Suspendido", tone: "bg-red-50 text-red-700" },
  cancelado: { label: "Cancelado", short: "Cancelado", tone: "bg-slate-100 text-slate-600" },
};

export const STAGE_ORDER = ["pendiente_gerente_area", "pendiente_superintendente", "pendiente_admin", "pendiente_gerente_general", "por_pagar", "pagado"];

export const PROJECT_DOC_GROUPS = [
  { value: "planos", label: "Planos" },
  { value: "varios", label: "Documentos varios (Drive)" },
  { value: "estudios", label: "Estudios técnicos" },
  { value: "licencias", label: "Licencias y permisos" },
  { value: "otros", label: "Otros" },
];

export const STUDY_SUGGESTIONS = [
  "Memoria de cálculo", "Estudio de topografía", "Estabilidad de taludes",
  "Protección civil", "Visto bueno de bomberos", "Mecánica de suelos",
  "Estudio geológico", "Licencia de uso de suelo", "Licencia de construcción",
  "Régimen de condominio",
];

export const PLANOS_CONFIG = {
  section: "planos",
  overline: "Documentación y control de cambios",
  title: "Planos y Estudios",
  groups: PROJECT_DOC_GROUPS,
  suggestions: STUDY_SUGGESTIONS,
};

export const NORMATIVA_GROUPS = [
  { value: "reglamento_interno", label: "Reglamento interno" },
  { value: "reglamento_seguridad", label: "Reglamentos de seguridad" },
  { value: "plan_contingencia", label: "Planes de contingencia" },
  { value: "protocolo", label: "Protocolos y procedimientos" },
  { value: "otros_normativa", label: "Otros" },
];

export const NORMATIVA_SUGGESTIONS = [
  "Reglamento interno de trabajo", "Reglamento de seguridad e higiene",
  "Plan de contingencia", "Protocolo de emergencia", "Plan de evacuación",
  "Análisis de riesgos de trabajo", "Programa de protección civil",
  "Uso obligatorio de EPP", "Plan de primeros auxilios", "Ruta de evacuación",
];

export const NORMATIVA_CONFIG = {
  section: "normativa",
  overline: "Seguridad, salud y cumplimiento",
  title: "Reglamentos y Seguridad",
  groups: NORMATIVA_GROUPS,
  suggestions: NORMATIVA_SUGGESTIONS,
};

export const LEGALES_GROUPS = [
  { value: "contratos_legales", label: "Contratos firmados" },
  { value: "poderes", label: "Poderes y representación" },
  { value: "actas", label: "Actas constitutivas / asambleas" },
  { value: "escrituras", label: "Escrituras y propiedad" },
  { value: "permisos_legales", label: "Permisos y licencias" },
  { value: "otros_legales", label: "Otros legales" },
];

export const LEGALES_SUGGESTIONS = [
  "Acta constitutiva", "Poder notarial", "Escritura pública", "Contrato firmado",
  "Identificación oficial", "Comprobante de domicilio", "Constancia de situación fiscal",
  "Opinión de cumplimiento (32-D)", "Póliza de fianza", "Convenio modificatorio", "Acta de asamblea",
];

export const LEGALES_CONFIG = {
  section: "legal",
  overline: "Documentación jurídica y cumplimiento",
  title: "Legal",
  groups: LEGALES_GROUPS,
  suggestions: LEGALES_SUGGESTIONS,
};

export const CONTABLE_GROUPS = [
  { value: "facturas", label: "Facturas (CFDI)" },
  { value: "fiscales", label: "Fiscal (RFC / CSF / opinión)" },
  { value: "polizas", label: "Pólizas contables" },
  { value: "estados_banco", label: "Estados de cuenta bancarios" },
  { value: "conciliaciones", label: "Conciliaciones" },
  { value: "impuestos", label: "Impuestos y declaraciones" },
  { value: "nominas", label: "Nóminas" },
  { value: "otros_contable", label: "Otros contables" },
];

export const CONTABLE_SUGGESTIONS = [
  "Factura CFDI", "Complemento de pago", "Póliza de diario", "Póliza de egresos",
  "Estado de cuenta bancario", "Conciliación bancaria", "Declaración mensual",
  "Declaración anual", "Recibo de nómina", "Balance general", "Estado de resultados",
];

export const CONTABLE_CONFIG = {
  section: "contable",
  overline: "Contabilidad y finanzas",
  title: "Contable",
  groups: CONTABLE_GROUPS,
  suggestions: CONTABLE_SUGGESTIONS,
};

export const SECTIONS = [
  { to: "/", label: "Panel" },
  { to: "/contratistas", label: "Contratistas" },
  { to: "/proveedores", label: "Proveedores" },
  { to: "/contratos", label: "Contratos" },
  { to: "/ordenes-trabajo", label: "Órdenes de Trabajo" },
  { to: "/directorio", label: "Directorio de Empresas" },
  { to: "/estimaciones", label: "Estimaciones / Pagos" },
  { to: "/estado-cuenta", label: "Estado de Cuenta" },
  { to: "/acceso", label: "Control de Acceso" },
  { to: "/partidas", label: "Avance / Calidad" },
  { to: "/bitacora", label: "Bitácora" },
  { to: "/tareas", label: "Pendientes" },
  { to: "/programa", label: "Programa de Obra" },
  { to: "/chat", label: "Chat del equipo" },
  { to: "/fotografias", label: "Fotos de obra" },
  { to: "/recorridos", label: "Recorridos 360°" },
  { to: "/empleados", label: "Empleados" },
  { to: "/documentos", label: "Planos y Estudios" },
  { to: "/normativa", label: "Reglamentos y Seguridad" },
  { to: "/concursos", label: "Concursos / Cotizaciones" },
  { to: "/reportes", label: "Reportes PDF" },
  { to: "/erp", label: "Reporte ERP (Pagos)" },
  { to: "/auditorias", label: "Auditorías externas" },
  { to: "/eliminados", label: "Eliminados" },
  { to: "/gastos-fijos", label: "Gastos Fijos" },
];

export const ROLE_OPTIONS = [
  { value: "contratista", label: "Contratista" },
  { value: "seguridad", label: "Seguridad (solo Control de Acceso)" },
  { value: "supervisor", label: "Supervisor" },
  { value: "gerente_area", label: "Gerente de Área" },
  { value: "superintendente", label: "Superintendente" },
  { value: "gerente_administrativo", label: "Gerente Administrativo" },
  { value: "gerente_general", label: "Gerente General" },
  { value: "admin", label: "Administrador" },
];

export const roleLabel = (v) => (ROLE_OPTIONS.find((r) => r.value === v) || {}).label || v;
